import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import supabase from "../config/supabaseClient";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Home = () => {
    const navigate = useNavigate();
    const [shirt, setShirt] = useState(null);
    const [pant, setPant] = useState(null);

    // Fetch Shirt data from Supabase
    useEffect(() => {
        const fetchShirt = async () => {
            const { data, error } = await supabase
                .from("products")
                .select("name, description, image_url")
                .eq("name", "Shirt")
                .single();

            if (error) {
                console.error("Error fetching shirt:", error.message);
            } else {
                setShirt(data);
            }
        };

        const fetchPant = async () => {
            const { data, error } = await supabase
                .from("products")
                .select("name, description, image_url")
                .eq("name", "Pants")
                .single();

            if (error) {
                console.error("Error fetching pant:", error.message);
            } else {
                setPant(data);
            }
        };

        fetchShirt();
        fetchPant();
    }, []);

    const categories = [
        {
            name: "Shirts",
            path: "/products/1",
        },
        {
            name: "Pants",
            path: "/products/2",
        },
    ];

    return (
        <div className="min-h-screen flex flex-col bg-black text-[#f5c6d6]">
            {/* Importing Header */}
            <Header />

            {/* Main Content */}
            <div className="flex-grow pt-20 pb-12 px-4">
                {/* Hero Section */}
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    className="text-center max-w-3xl mx-auto p-6"
                >
                    <motion.h2
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                        className="text-4xl md:text-5xl font-extrabold mb-6 tracking-wide leading-tight"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                        Welcome to{" "}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#ff758c] to-[#ff7eb3]">
                            De Vānā Designs
                        </span>
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="text-base md:text-lg mb-8 text-gray-300"
                    >
                        Explore the latest dressing trends and discover your new style today!
                    </motion.p>

                    <motion.button
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                        className="btn btn-primary w-full sm:w-60"
                    >
                        <Link to="/products">Explore Collection</Link>
                    </motion.button>
                </motion.div>

                {/* Categories Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.7, duration: 0.8 }}
                    className="max-w-5xl mx-auto mt-12 p-4"
                >
                    <h3 className="text-2xl md:text-3xl font-bold text-center mb-8">Categories</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {categories.map((category, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className="cursor-pointer glass text-center p-6 shadow-lg hover:shadow-2xl transition"
                                onClick={() => navigate(category.path)}
                            >
                                <img
                                    src={
                                        category.name === "Shirts"
                                            ? shirt?.image_url
                                            : "https://afvhcaqgrvotvgnhqupx.supabase.co/storage/v1/object/public/product-images//pant.jpeg"
                                    }
                                    alt={category.name}
                                    className="w-full h-32 md:h-40 object-cover mb-4 rounded-lg"
                                />
                                <h2 className="text-xl md:text-2xl font-semibold">{category.name}</h2>
                                {category.name === "Shirts" && shirt?.description && (
                                    <p className="text-sm md:text-base text-gray-300 mt-2">{shirt.description}</p>
                                )}
                                {category.name === "Pants" && pant?.description && (
                                    <p className="text-sm md:text-base text-gray-300 mt-2">{pant.description}</p>
                                )}
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>

            {/* Footer Section */}
            <Footer />
        </div>
    );
};

export default Home;
